<template>
  <div class="check-work-body" style="width: 100%">
    <el-tabs type="border-card" v-model="activeName">
      <el-tab-pane label="超时流程统计报表" name="flowTimeout">
        <div>
          <div class="search-wrap">
            <div class="spacing">
              <el-select size="mini" v-model="self_where.group" placeholder="架构" style="width: 250px">
                <el-option label="集团总部" :value=1></el-option>
                <el-option label="广东中奥物业管理有限公司" :value=3918></el-option>
                <el-option label="广东中奥城市运营服务有限公司" :value=1117></el-option>
                <el-option label="广东迅华电气技术有限公司" :value=739></el-option>
                <el-option label="广东迅龙电梯有限公司" :value=1801></el-option>
              </el-select>
            </div>
            <div class="spacing">
            <el-input size="mini" placeholder="请输入流程名称"  clearable
                      v-model="self_where.process_name"
                      style="width: 200px"></el-input>
            </div>
            <div class="spacing">
              <el-input size="mini" placeholder="请输入节点名称"  clearable
                        v-model="self_where.node_name"
                        style="width: 200px"></el-input>
            </div>
            <div class="spacing">
              <el-input size="mini" placeholder="节点审批人"  clearable
                        v-model="self_where.node_user_name"
                        style="width: 150px"></el-input>
            </div>
            <div class="spacing">
              <el-select size="mini" v-model="self_where.timeout_type" placeholder="请选择审批时长" style="width: 150px">
                <el-option label="全部" :value="-1"></el-option>
                <el-option label="超24小时" :value=24></el-option>
                <el-option label="超48小时" :value=48></el-option>
                <el-option label="超72小时" :value=72></el-option>
              </el-select>
            </div>
            <div class="spacing">
              接收日期
              <el-date-picker
                size="mini"
                v-model="self_where.start_timeout"
                type="date"
                placeholder="开始日期">
              </el-date-picker>
              至
              <el-date-picker
                size="mini"
                v-model="self_where.end_timeout"
                type="date"
                placeholder="结束日期">
              </el-date-picker>
            </div>
            <div class="spacing">
              <el-button size="mini" @click="search">搜索</el-button>
              <el-button size="mini" @click="exportExecl">导出</el-button>
            </div>
          </div>
          <FlowTimeoutLog v-if="re_load_status" :where="self_where" />
        </div>
      </el-tab-pane>
      <el-tab-pane label="流程统计分析" name="flowTimeoutReport2">
        <div>
          <div class="search-wrap">
            <div class="spacing">
              <el-select size="mini" v-model="echarts_where.group" placeholder="架构" style="width: 250px">
                <el-option label="集团总部" :value=1></el-option>
                <el-option label="广东中奥物业管理有限公司" :value=3918></el-option>
                <el-option label="广东中奥城市运营服务有限公司" :value=1117></el-option>
                <el-option label="广东迅华电气技术有限公司" :value=739></el-option>
                <el-option label="广东迅龙电梯有限公司" :value=1801></el-option>
              </el-select>
            </div>
            <div class="spacing">
              <el-select size="mini" v-model="echarts_where.timeout_type" placeholder="请选择审批时长" style="width: 150px">
                <el-option label="超24小时" :value=24></el-option>
                <el-option label="超48小时" :value=48></el-option>
                <el-option label="超72小时" :value=72></el-option>
              </el-select>
            </div>
            <div class="spacing">
              接收日期
              <el-date-picker
                size="mini"
                v-model="echarts_where.start_timeout"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="开始日期">
              </el-date-picker>
              至
              <el-date-picker
                size="mini"
                v-model="echarts_where.end_timeout"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="结束日期">
              </el-date-picker>
            </div>
            <div class="spacing">
              <el-button size="mini" @click="searchReport">搜索</el-button>
              <el-button size="mini" @click="exportExeclReport">导出</el-button>
            </div>
          </div>
          <el-row :gutter="10">
            <el-col :span="24">
              <div class="grid-content border" >
                <div v-loading="loading" id="flowAreaTimeOut" style="padding: 32px 0px 0px 32px; height: 350px;"></div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <div class="grid-content border" >
                <div v-loading="loading" id="flowAreaTimeOutUser" style="padding: 32px 0px 0px 32px; height: 350px;"></div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import * as echarts from 'echarts';
import Http from "./common/Http";
import FlowTimeoutLog from "./components/FlowTimeoutLog";
import moment from "moment";

export default {
  name:"FlowTimeoutReport",
  components: {FlowTimeoutLog},
  data () {
    return {
      loading: false,
      dialogVisible:false,
      self_where:{
        process_name: '',
        node_user_name: '',
        start_timeout: '',
        end_timeout: '',
        node_name: '',
        is_finish: '',
        group: 3918,
      },
      echarts_where: {
        start_timeout: '',
        end_timeout: '',
        timeout_type: 24,
        group: 3918,
        export_type: 'report'
      },
      flow_data: {
        flow_total:0,
        end_total:0,
        action_total:0,
        avg_use_time:''
      },
      re_load_status:true,
      activeName:'flowTimeoutReport2'
    }
  },
  created() {

  },
  mounted() {
    if (this.echarts_where.start_timeout === '') {
      let currentDate = new Date();
      let year = currentDate.getFullYear();
      let month = currentDate.getMonth() + 1; // 月份从0开始，需要加1
      let day = currentDate.getDate();
      let lastDate = new Date(year, month, 0).getDate();

      this.echarts_where.start_timeout = `${year}-${month}-01`;
      this.echarts_where.end_timeout = `${year}-${month}-${lastDate}`;
    }
    this.getFlowAreaTimeOut()
    this.getFlowAreaTimeOutUser()

  },
  watch: {

  },
  methods: {
    search() {
      let that = this;
      // 获取数据
      Http.get("flow/FlowReport/flowTimeOutList",{
        where:JSON.stringify(that.where),
      },res=>{
        if(res.code) {

          }
      })
    },
    searchReport() {
      this.getFlowAreaTimeOut()
      this.getFlowAreaTimeOutUser()
    },

    // 区域超时流程占比统计
    getFlowAreaTimeOut() {
      let that = this;
      that.loading = true
      Http.get("flow/FlowReport/getFlowAreaTimeOutReport",that.echarts_where,res=>{
        that.loading = false
        if(res.code) {
          let data = res.data
          let chartDom = document.getElementById('flowAreaTimeOut');
          let myChart = echarts.init(chartDom);
          let option;
          let yData = []
          let yData2 = []
          let xData = []
          for(let i=0; i<data.length; i++) {
            xData.push(data[i]['branch_name'])
            yData.push(data[i]['total'])
            yData2.push(data[i]['proportion'])
          }
          option = {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                crossStyle: {
                  color: '#999'
                }
              }
            },
            title: {
              text: "区域超时流程占比统计",
              left: 'center'
            },
            yAxis: [{
              type: 'value',
              name: '次数',
              axisLabel: {
                formatter: '{value} '
              },

            }, {
                type: 'value',
                name: '占比',
                axisLabel: {
                  formatter: '{value} %'
                }
            }],
            xAxis: {
              type: 'category',
              data: xData,
              axisPointer: {
                type: 'shadow'
              },
              axisLabel: { interval: 0, rotate: 30 }
            },
            series: [
              {
                name: '次数',
                type: 'bar',
                tooltip: {
                  valueFormatter: function (value) {
                    return value;
                  }
                },
                label: {
                  show: true,
                  position: 'top'
                },
                data: yData
              },
              {
                name: '占比',
                type: 'line',
                yAxisIndex: 1,
                tooltip: {
                  valueFormatter: function (value) {
                    return value + '%';
                  }
                },
                data: yData2
              },
            ],
          };
          myChart.setOption(option);
        }
      })
    },

    // 人员超时流程统计
    getFlowAreaTimeOutUser() {
      let that = this;
      that.loading = true
      Http.get("flow/FlowReport/getFlowUserTimeOutReport",that.echarts_where,res=>{
        that.loading = false
        if(res.code) {
          let data = res.data
          let chartDom = document.getElementById('flowAreaTimeOutUser');
          let myChart = echarts.init(chartDom);
          let option;
          let yData = []
          let xData = []
          for(let i=0; i<data.length; i++) {
            xData.push(data[i]['UserName'])
            yData.push(data[i]['total'])
          }
          option = {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                crossStyle: {
                  color: '#999'
                }
              }
            },
            title: {
              text: "超时人员统计",
              left: 'center'
            },
            yAxis: [{
              type: 'value',
              name: '超时次数',
              axisLabel: {
                formatter: '{value} '
              }
            }],
            xAxis: {
              type: 'category',
              data: xData,
              axisPointer: {
                type: 'shadow'
              },
              axisLabel: { interval: 0, rotate: 30 }
            },
            series: [
              {
                name: '超时次数',
                type: 'bar',
                tooltip: {
                  valueFormatter: function (value) {
                    return value;
                  }
                },
                label: {
                  show: true,
                  position: 'top'
                },
                data: yData
              },
            ],
          };
          myChart.setOption(option);
        }
      })
    },

    // 导出execl
    exportExecl() {
      let that = this;
      Http.get("flow/FlowTimeoutLog/exportExecl",{
        where:JSON.stringify(that.self_where),
      },res=>{
        if(res.code) {
          if (res) {
            window.open(Http.getBaseURL() + res.data)
            this.$message({
              message: '导出成功',
              type: 'success'
            });
          } else {
            this.$message.error({
              message: '导出失败',
              type: "error",
            });
          }
        }
      })
    },
    // 导出报表数据
    exportExeclReport() {
      let that = this;
      Http.get("flow/FlowTimeoutLog/exportExecl",{
        where:JSON.stringify(that.echarts_where),
      },res=>{
        if(res.code) {
          if (res) {
            window.open(Http.getBaseURL() + res.data)
            this.$message({
              message: '导出成功',
              type: 'success'
            });
          } else {
            this.$message.error({
              message: '导出失败',
              type: "error",
            });
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 200px );
  overflow-x: scroll;
}
.spacing {
  display: inline-block;
  margin-right: 10px;
}
.el-row {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  //background: #99a9bf;
}
.bg-purple {
  //background: #d3dce6;
}
.bg-purple-light {
  //background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 80px;
}
.border {
  border: 1px solid #e8e8e8;
}
.row-bg {
  padding: 5px 0;
  background-color: #f9fafc;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/FlowTimeoutReport.vue